"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var input_trim_directive_1 = require("./input-trim.directive");
var InputTrimModule = (function () {
    function InputTrimModule() {
    }
    InputTrimModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [],
                    exports: [input_trim_directive_1.InputTrimDirective],
                    declarations: [input_trim_directive_1.InputTrimDirective],
                    providers: [],
                },] },
    ];
    InputTrimModule.ctorParameters = function () { return []; };
    return InputTrimModule;
}());
exports.InputTrimModule = InputTrimModule;



//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-trim-directive/dist/input-trim.module.js
// module id = ../../../../ng2-trim-directive/dist/input-trim.module.js
// module chunks = 4